import {nombreZonaEnPlano} from '../../utils/presentacionZona';
import React, { lazy, Suspense, useEffect, useMemo, useState } from 'react';
import { escenaPalmarama } from '../../utils/planimetria';
import '../../pages/recintos/Recintos.css';
const EMPTY_IDS=Object.freeze([]);
const Scene3D = lazy(() => import('./Scene3D'));
export default function MapaRecinto3D({
  plano,
  zonas,
  onZonaClick,
  disabled = false,
  paused = false,
  disabledIds = EMPTY_IDS,
  seleccionadaId
}) {
  const scene = useMemo(() => {
    if (plano) return plano;
    const s = escenaPalmarama();
    return {
      ...s,
      objects: s.objects.map(o => {
        const z = zonas.find(z => z.id === o.id);
        return z ? {
          ...o,
          name: z.label,
          x: (z.x + z.width / 2) * .05 - 18,
          z: (z.y + z.height / 2) * .05 - 28,
          w: z.width * .05,
          d: z.height * .05
        } : o;
      })
    };
  }, [plano, zonas]);
  const [floorId, setFloor] = useState('all'),
    [view, setView] = useState('perspectiva'),
    [search, setSearch] = useState(''),
    [focus, setFocus] = useState(null),
    [selected, setSelected] = useState('');
  const initialView=JSON.stringify(scene.views?.find(v=>v.floorId==='all'&&v.fitToScene)||null);
  useEffect(()=>{
    setFloor('all');
    setFocus(initialView==='null'?null:{pose:JSON.parse(initialView),t:Date.now()});
  },[initialView]);
  useEffect(() => {
    if (floorId !== 'all' && !scene.floors.some(f => f.id === floorId)) setFloor('all');
  }, [scene, floorId]);
  const estados = useMemo(() => Object.fromEntries(zonas.map(z => [z.id, z.estado])), [zonas]);
  const blocked = useMemo(() => zonas.filter(z => disabled || z.bloqueada || disabledIds.includes(z.id)).map(z => z.id), [zonas, disabled, disabledIds]);
  const seleccion = seleccionadaId || selected;
  const seleccion3d=useMemo(()=>seleccion?[seleccion]:[],[seleccion]);
  function elegir(id) {
    const z = zonas.find(z => z.id === id);
    if (!z || blocked.includes(id)) return;
    setSelected(id);
    onZonaClick(z);
  }
  return <section className="recinto-operation" aria-label="Planimetría 3D">
    <div className="recinto-operation-controls"><select aria-label="Piso del recinto" value={floorId} onChange={e => setFloor(e.target.value)}>{scene.floors.map(f => <option key={f.id} value={f.id}>{f.name}</option>)}<option value="all">Todos los pisos</option></select><select aria-label="Vista 3D" value={view} onChange={e => setView(e.target.value)}><option value="perspectiva">Perspectiva</option><option value="superior">Superior</option><option value="interior">Interior</option><option value="frontal">Frontal</option></select><input aria-label="Buscar zona en el recinto" placeholder="Buscar mesa o lounge…" value={search} onChange={e => setSearch(e.target.value)} /><button type="button" onClick={() => setFocus({
        t: Date.now()
      })}>Centrar recinto</button><button type="button" aria-label="Acercar plano" onClick={()=>setFocus({zoomFactor:1.25,t:Date.now()})}>＋ Acercar</button><button type="button" aria-label="Alejar plano" onClick={()=>setFocus({zoomFactor:.8,t:Date.now()})}>− Alejar</button></div>
    <div className="recinto-operation-legend">Verde: libre · Amarillo: reservada · Rojo: prepagada · Atenuado: no seleccionable<br/>Vista general: M = mesa · L = lounge · P = palco. Acércate para ver los nombres completos.</div>
    <div className="recinto-operation-stage"><Suspense fallback={<p>Cargando vista 3D…</p>}><Scene3D scene={scene} paused={paused} readOnly floorId={floorId} view={view} selection={seleccion3d} disabledIds={blocked} zoneStates={estados} onZoneClick={elegir} transparentWalls cameraRequest={focus} /></Suspense></div>
    <div className="recinto-operation-choices" aria-label="Zonas del piso">{zonas.filter(z => {
        const o = scene.objects.find(o => o.id === z.id);
        return o && (floorId === 'all' || o.floorId === floorId) && z.label.toLowerCase().includes(search.toLowerCase());
      }).map(z => <button className={`recinto-zone-${z.estado}`} key={z.id} type="button" aria-label={`${z.label} · ${z.estado}${blocked.includes(z.id) ? ' · no seleccionable' : ''}`} aria-pressed={seleccion === z.id} disabled={blocked.includes(z.id)} onClick={() => {
        setFocus({
          id: z.id,
          t: Date.now()
        });
        elegir(z.id);
      }}>{nombreZonaEnPlano(z)}</button>)}</div>
  </section>;
}
